import AttritionAndCancelReasonsReducer from "./redux/attritionAndCancelReasonsReducer";
import AttritionAndCancelReasonsSagas from "./redux/attritionAndCancelReasonsSaga";
import { AttritionAndCancelReasonsModule } from "./attritionAndCancelReasonsModule";

export default {
  Component: AttritionAndCancelReasonsModule,
  moduleName: "attritionAndCancelReasons",
  saga: AttritionAndCancelReasonsSagas(),
  reducer: AttritionAndCancelReasonsReducer
};
